export default "__VITE_ASSET__7c3efe35__"